const Theme = {
    body_background_color: '#FECC2D',

    header_padding: '5',

    logo_image_url: 'accordeon.png',
    logo_height: 160,

    button_color: '#A6D0FF',
    button_radius: 12,

    button_half_border_color: '#A6D0FF',

    text_font: `'Raleway', sans-serif`,

    title_font: `'Raleway', sans-serif`,

    subtitle_font: `'Raleway', sans-serif`,

  }

  export default Theme
